// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (min-width: 1920px) {
}

@media (max-width: 1440px) {
}

@media (max-width: 1367px) {
  .q-sv-single-product .single-p-select-variant-btn {
    font-size: 13px;
  }
  .slick-initialized .slick-slide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

@media (max-width: 1281px) {
}

@media (max-width: 1280px) {
}

@media (max-width: 1279px) {
}
@media (max-width: 1200px) {
}

@media (max-width: 1024px) {
  .main-authentication-component .wrapper {
    display: none;
  }
  .main-authentication-component {
    height: 96vh;
  }
}

@media (max-width: 1023px) {
}

@media (max-width: 991px) {
}
@media (max-width: 950px) {
}
@media (max-width: 800px) {
}
@media (max-width: 768px) {
  .footer_area_inner {
    width: 90%;
  }
  .quicvee-home-banner img.DesktopBanner {
    display: none;
  }
  .quicvee-home-banner img.MobileBanner {
    display: block;
  }
  .basic-modal {
    width: 95%;
  }
  .delivery-address-update-form {
    /* display: unset; */
  }
}
@media (max-width: 767px) {
  /* .order-top-bar-search {
    display: none;
  } */
  .header_area {
    margin-bottom: 0;
  }

  .order-top-bar-search {
    justify-content: space-between;
    border-radius: 0px;
    width: 100%;
  }

  .footer_areaL {
    width: 100%;
    text-align: center;
  }
  .footer_areaR {
    width: 100%;
    text-align: center;
  }
  .footer_areaR ul {
    float: unset;
    display: inline-block;
    margin-bottom: 0px;
    margin-top: 10px;
  }
  .home_page_top_category_div_inner {
    width: 70px;
    height: 70px;
  }
  .q-single-category-link-home > span {
    font-size: 14px;
  }
}

@media (max-width: 515px) {
  .footer_area_inner {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .footer_areaR ul li {
    width: 50%;
    margin-bottom: 8px;
  }

  .footer_areaR ul li:nth-child(2),
  .footer_areaR ul li:nth-child(4) {
    border-right: 0;
  }
}

@media (max-width: 479px) {
}

@media (max-width: 420px) {
}
@media (max-width: 419px) {
}
@media (max-width: 380px) {
}
`, "",{"version":3,"sources":["webpack://./src/Styles/media.css"],"names":[],"mappings":"AAAA;AACA;;AAEA;AACA;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;AACA;;AAEA;AACA;;AAEA;AACA;AACA;AACA;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;AACF;;AAEA;AACA;;AAEA;AACA;AACA;AACA;AACA;AACA;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,UAAU;EACZ;EACA;IACE,oBAAoB;EACtB;AACF;AACA;EACE;;KAEG;EACH;IACE,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;AACA;;AAEA;AACA;AACA;AACA;AACA;AACA","sourcesContent":["@media (min-width: 1920px) {\r\n}\r\n\r\n@media (max-width: 1440px) {\r\n}\r\n\r\n@media (max-width: 1367px) {\r\n  .q-sv-single-product .single-p-select-variant-btn {\r\n    font-size: 13px;\r\n  }\r\n  .slick-initialized .slick-slide {\r\n    padding-left: 10px;\r\n    padding-right: 10px;\r\n  }\r\n}\r\n\r\n@media (max-width: 1281px) {\r\n}\r\n\r\n@media (max-width: 1280px) {\r\n}\r\n\r\n@media (max-width: 1279px) {\r\n}\r\n@media (max-width: 1200px) {\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .main-authentication-component .wrapper {\r\n    display: none;\r\n  }\r\n  .main-authentication-component {\r\n    height: 96vh;\r\n  }\r\n}\r\n\r\n@media (max-width: 1023px) {\r\n}\r\n\r\n@media (max-width: 991px) {\r\n}\r\n@media (max-width: 950px) {\r\n}\r\n@media (max-width: 800px) {\r\n}\r\n@media (max-width: 768px) {\r\n  .footer_area_inner {\r\n    width: 90%;\r\n  }\r\n  .quicvee-home-banner img.DesktopBanner {\r\n    display: none;\r\n  }\r\n  .quicvee-home-banner img.MobileBanner {\r\n    display: block;\r\n  }\r\n  .basic-modal {\r\n    width: 95%;\r\n  }\r\n  .delivery-address-update-form {\r\n    /* display: unset; */\r\n  }\r\n}\r\n@media (max-width: 767px) {\r\n  /* .order-top-bar-search {\r\n    display: none;\r\n  } */\r\n  .header_area {\r\n    margin-bottom: 0;\r\n  }\r\n\r\n  .order-top-bar-search {\r\n    justify-content: space-between;\r\n    border-radius: 0px;\r\n    width: 100%;\r\n  }\r\n\r\n  .footer_areaL {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n  .footer_areaR {\r\n    width: 100%;\r\n    text-align: center;\r\n  }\r\n  .footer_areaR ul {\r\n    float: unset;\r\n    display: inline-block;\r\n    margin-bottom: 0px;\r\n    margin-top: 10px;\r\n  }\r\n  .home_page_top_category_div_inner {\r\n    width: 70px;\r\n    height: 70px;\r\n  }\r\n  .q-single-category-link-home > span {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n@media (max-width: 515px) {\r\n  .footer_area_inner {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .footer_areaR ul li {\r\n    width: 50%;\r\n    margin-bottom: 8px;\r\n  }\r\n\r\n  .footer_areaR ul li:nth-child(2),\r\n  .footer_areaR ul li:nth-child(4) {\r\n    border-right: 0;\r\n  }\r\n}\r\n\r\n@media (max-width: 479px) {\r\n}\r\n\r\n@media (max-width: 420px) {\r\n}\r\n@media (max-width: 419px) {\r\n}\r\n@media (max-width: 380px) {\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
